export default __webpack_public_path__ + "static/media/dl-confirm.d76e5bdc.png";